import React, { Component } from 'react';
import { Row, Col, Input, Modal } from 'antd';
import $ from 'jquery';

const { TextArea } = Input;

class NewDesignation extends Component {

    constructor( props ){
        super( props );

        this.state = {
            visible: false,
            name: 'none',
            email: '',
        }

        this.handleOk = this.handleOk.bind( this );
        this.handleCancel = this.handleCancel.bind( this );    
    }

    handleOk = (e) => {

        if( this.state.name === "" || this.state.name === "none" ){
            this.setState({
                name: ''
            })
            return false;
        }

        this.props.onSubmit( this.state );

        this.setState({ visible: false });
    
    }

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }
    
    componentWillReceiveProps( nextProps ){
        // Clear Input
        $('input').val( '' );

        this.setState({
            visible: nextProps.onModel
        });

    }

    render() {
        return (

            <Modal
                title="Add New Designation"
                maskClosable={ false }
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                >
                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label  className={ ( this.state.name === '') ? 'error': '' }>Designation Name</label>
                        <Input className={ ( this.state.name === '') ? 'br_error': '' } onChange={ (e)=> this.setState({ name: e.target.value }) } size="default"  />
                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={24}>
                        <label>Mail Alias</label>
                        <Input onChange={ (e)=> this.setState({ email: e.target.value }) } size="default"  />
                    </Col>
                </Row>
            </Modal>

        )
    }
}

export default NewDesignation


                    
                


// WEBPACK FOOTER //
// ./src/pages/designation/childs/new.designation.js